export const stripHtml = (value: string): string =>
  typeof value === 'string' ? value.replace(/<[^>]+>/g, '') : value;
